import { useMutation, useQueryClient } from '@tanstack/react-query';
import { domainQueryKeys, Domains } from '#api';

/** Used to delete unused domains */
export function useDeleteDomainMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (domainId: string) => Domains.deleteDomain(domainId),
    onSuccess: (data, domainId) => {
      queryClient.removeQueries({ queryKey: domainQueryKeys.detail(domainId), exact: true });
      void queryClient.invalidateQueries({ queryKey: domainQueryKeys.lists() });
    },
  });
}
